import React from 'react';
import styled from 'styled-components';
import Label1 from '../../../assets/images/labels/label1.png';
import Label2 from '../../../assets/images/labels/label2.png';
import Label3 from '../../../assets/images/labels/label3.png';
import Label4 from '../../../assets/images/labels/label4.png';
import Label5 from '../../../assets/images/labels/label5.png';
import Label6 from '../../../assets/images/labels/label6.png';

const Labels = styled.ul`
  --m: 8px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: calc(var(--m) * -1) calc(var(--m) * -2);
`;

const LabelsItem = styled.li`
  flex-shrink: 0;
  margin: var(--m) calc(var(--m) * 2);
`;

const Label = styled.img`
  display: block;
  height: 60px;
  width: auto;
`;

const labels = [
  {
    filepath: `${Label1}`,
    alt: 'Logo of the music label Warner Classics Erato',
  },
  {
    filepath: `${Label2}`,
    alt: 'Logo of the music label ECM',
  },
  {
    filepath: `${Label3}`,
    alt: 'Logo of the music label Deutsche Grammophon',
  },
  {
    filepath: `${Label4}`,
    alt: 'Logo of the music label Decca',
  },
  {
    filepath: `${Label5}`,
    alt: 'Logo of the music label Sony Classical',
  },
  {
    filepath: `${Label6}`,
    alt: 'Logo of the music label harmonia mundi',
  },
];

export default () => {
  return (
    <Labels>
      {labels.map(({ filepath, alt }, i) => (
        <LabelsItem key={i}>
          <Label src={filepath} alt={alt} />
        </LabelsItem>
      ))}
    </Labels>
  );
};



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/labels/Labels.js